<template>
  <KfDesktop>
    <div class="desktop">
      <PrcMobileApp1/>
    </div>
  </KfDesktop>
</template>
<script>


import PrcMobileApp1 from "@/views/mobile/prc/PrcMobileApp1.vue";

export default {
  name: 'DesktopMobile',
  components: {PrcMobileApp1},
  data() {
    return {
      pollingTimer: null,
    }
  },
  mounted() {
    //为移动端
    this.$store.state.core.mobile = true;
  },


  async created() {
    await this.loadConfig()

    let user = await this.$http('sysUserService.getCurrentUser');
    this.$store.commit('core/CURRENT_USER_INIT', user)
    await this.loadDefinition()
    await this.getUserApps();

    let data = await this.$http('sysDictService.selectAll')
    this.$store.commit('core/INIT_DICT', data)
  },
  computed: {
    user() {
      return this.$store.state.core.currentUser;
    },
    lock() {
      return this.$store.state.core.lock;
    }
  },
  methods: {

    polling() {
      let pollingTime = parseInt(this.$store.getters['core/getConfig']('polling_time')) || 0;
      if (pollingTime < 1 || this.pollingTimer) {
        return;
      }

      this.pollingTimer = setInterval(async () => {
        let dataKeys = this.$store.getters['core/getBadgeDataKeyList'];
        if (dataKeys.length == 0) {
          return;
        }

        this.$http('framePollingService.getPollingData', {data_keys: dataKeys}, false).then(data => {
          this.$store.commit('core/INIT_BADGE', data)

          let msg = this.$store.getters['core/getBadgeData']('one_un_send_msg');
          if (msg) {
            this.$notify.info({
              title: "收到新消息",
              message: msg.title,
              duration: 6000
            })
          }
        }, errMsg => {
          return this.$message.error(`Badge消息加载失败，${errMsg}`);
        })
      }, pollingTime * 1000)

    },
    async loadDefinition() {
      let data = await this.$http('frameUiService.loadDefinition')
      this.$store.commit('core/QUERY_DEF_INIT', data.queryList)
      this.$store.commit('core/TABLE_DEF_INIT', data.tableList)
      this.$store.commit('core/FORM_DEF_INIT', data.formList)
    },
    async loadConfig() {
      let data = await this.$http('sysConfigService.getWebConfig')
      this.$store.commit('core/INIT_SYS_CONFIG', data)
      this.$store.commit('wallpaper/INIT_CONFIG', data)
      document.title = this.$store.getters['core/getAppName']

      this.polling()
    },
    async getUserApps() {
      let data = await this.$http('frameUiService.getUserApps');
      this.$store.commit('core/INIT_USER_APP', data)
    },


    onClick() {
      this.$store.dispatch('core/selectIcon', this.item.id)
    },
    dblclick() {
      if (this.item.disabled) {
        return this.$message.error(this.$t('AppIcon.no_use', {name: this.item?.name}))
      } else if (this.item?.no_access) {
        return this.$message.error(this.$t('AppIcon.no_access', {name: this.item?.name}))
      }
      if (this.item.link_url) {
        window.open(this.item.link_url, "_blank");
        return;
      }

      let windowObj = {}
      windowObj.icon = this.item.icon;
      windowObj.component = this.item.component
      windowObj.componentParam = this.item.params
      windowObj.name = this.item.name;
      windowObj.badge_data_key = this.item.badge_data_key;
      windowObj.parentData = {
        form_component: this.item?.jsonObj?.form_component,
        show_tips: this.item?.jsonObj?.show_tips ?? false,
      }

      let win = this.item?.jsonObj?.window || {};
      windowObj.width = win.width || this.$store.getters['core/getGlobalWindowWidth']
      windowObj.height = win.height || this.$store.getters['core/getGlobalWindowHeight']
      windowObj.max = win.max || this.$store.getters['core/getGlobalWindowMax']
      // windowObj.max = true
      windowObj.max_icon = win.max_icon
      windowObj.min_icon = win.min_icon

      this.$store.dispatch('core/openWindow', windowObj)

    }

  },
  unmounted() {
    clearInterval(this.pollingTimer)
  }
};
</script>

<style lang="less" scoped>

.desktop {
  height: 100%;
  width: 100%;
  position: absolute;
  min-height: 600px;
  min-width: auto;
  top: 0;
  left: 0;
}

.grid-box {
  display: flex;
  flex-direction: column;
  height: calc(100% - 40px);

  .top {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-end;
    padding-bottom: 20px;
  }
}

.imgStyle {
  width: 450px;
}

</style>
